import React from 'react';
import { connect } from 'react-redux';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import DropdownItem from '@/components/DropdownItem';
import StandardToolsMenu from '@/components/tools/StandardToolsMenu';
import { confirmTokenDeletion, confirmTokenRevoke } from '../actions';
import { canDeleteToken, canDisableToken } from '../helper';

const TokenTools = ({
  category,
  token,
  allowDisable,
  allowDelete,
  showDelete,
  showRevoke,
  upward,
  listItem = false,
}) => (
  <StandardToolsMenu
    allowDelete={allowDelete}
    listItem={listItem}
    onDelete={() => showDelete(category, token.code)}
    upward={upward}
  >
    {token.jwt && (
    <CopyToClipboard text={token.jwt}>
      <DropdownItem icon="copy outline" textId="token.copy" />
    </CopyToClipboard>
    )}
    {allowDisable && (
    <DropdownItem
      icon="wait"
      textId="actions.expire"
      disabled={!token.active}
      onClick={() => showRevoke(category, token.code)}
    />
    )}
  </StandardToolsMenu>
);

const mapStateToProps = ({
  auth: {
    role,
  },
}, { category }) => (
  {
    allowDisable: canDisableToken(category, role),
    allowDelete: canDeleteToken(category, role),
  }
);

const mapDispatchToProps = {
  showDelete: confirmTokenDeletion,
  showRevoke: confirmTokenRevoke,
};

export default connect(mapStateToProps, mapDispatchToProps)(TokenTools);
